
    var riot = require('riot')
    //src: starling/src/tags/collapsed-card-adoption-popover.html
riot.tag2('collapsed-card-adoption-popover',
  '<popover ref="popover" position="above" title="{this.totalCardsPhrase()}" size="small"> <span onclick="{parent.toggleExpansion}" class="popover_link popover_link--left">Expand to view</span> <span onclick="{parent.undoClick}" class="popover_link popover_link--right">Undo</span> </popover>',
  '',
  'ref="main" style="pointer-events: auto;"', function(opts) {
'use strict';

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

this.canvas = opts.canvas;
this.canvas.collapsedCardAdoptionPopoverTag = this;
this.isOpen = false;
var shuttle = function shuttle(localRef, remoteRef) {
  if (!(localRef && localRef.parentNode && remoteRef)) {
    return;
  }
  localRef.parentNode.removeChild(localRef);
  remoteRef.appendChild(localRef);
  localRef.classList.remove('hidden');
};

this.totalCardsPhrase = function () {
  if (_this.count == 1) {
    return '1 card has been added';
  }
  return _this.count + ' cards have been added';
};

this.on('mount', function () {
  _this.refs.popover.on('close', _this.popoverClose);
});

this.summon = function (_ref) {
  var nodeTag = _ref.nodeTag,
      count = _ref.count;
  var popover = _this.refs.popover;

  _this.hide();
  shuttle(_this.refs.main, nodeTag.refs.container);
  _this.nodeTag = nodeTag;
  _this.count = count;
  _this.isOpen = true;
  popover.setTitle(_this.totalCardsPhrase());
  popover.show();
  clearTimeout(_this.timeout);
  _this.timeout = setTimeout(function () {
    _this.hide();
  }, 10000);
};

this.hide = function () {
  _this.refs.popover.hide();
  _this.nodeTag = null;
  _this.count = null;
  _this.isOpen = false;
};

this.toggleExpansion = function (e) {
  _this.nodeTag.toggleExpansion(e);
  _this.hide();
};

this.undoClick = function () {
  if (_this.canvas.isViewOnly()) return;
  _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.canvas.operation.undo();

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
  _this.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('collapsed-card-adoption-popover')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/collapsed-card-adoption-popover.html
// module id = 665
// module chunks = 0